export default __webpack_public_path__ + "static/media/racingWeb@3x.07f1e000.png";